export default __webpack_public_path__ + "static/media/cvod-g.33b18c44.svg";